import { connect } from 'react-redux';
import ChangePassword from 'account/components/change_password';

const mapStateToProps = state => ({
  user: state.user,
});

export default connect(mapStateToProps)(ChangePassword);



// WEBPACK FOOTER //
// ./account/containers/change_password.jsx